var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pack"},[_c('ul',{staticClass:"uk-child-width-1-3@s uk-grid-match uk-grid-medium",attrs:{"uk-grid":""}},_vm._l((_vm.items),function(item){return _c('pack-item',{key:item.id,attrs:{"item":item,"currentId":_vm.currentItem.id},on:{"changePrice":_vm.changePrice}})}),1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250c15f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./themes/polza/src/js/components/commerce/pack.vue
// module id = 92
// module chunks = 0